import { Layout } from "antd";
import React from "react";
import AdminSiderContent from "../components/LeftSider/AdminSiderContent";
import "./MainLayout.scss";

const { Content } = Layout;

const MainLayout = ({ children, isFullScreen = false }) => {
  return (
    <Layout className={`MainAdminLayout ${isFullScreen && "full-screen"}`}>
      <Content>
        <Layout>
          <AdminSiderContent />
          <div className="main-content-layout">{children}</div>
        </Layout>
      </Content>
    </Layout>
  );
};
export default MainLayout;
